/**
 * Shared constants and utilities for external links.
 * Centralised here so they can be reused across components
 * (summary card, error states, onboarding, etc.)
 */

export const CHROME_EXTENSION_URL =
  'https://chromewebstore.google.com/detail/reedle-save-to-read-later/bjcolallmgbdflfjohhgoiipakidnhlg';

export const FEEDBACK_BASE_URL = 'https://feedback.iopho.com/';

/**
 * Build a pre-filled feedback URL.
 * @param {string} urlOrDomain - Full article URL or bare hostname. Null-safe.
 * @param {string} type        - Feedback category (default: 'extraction_failure')
 * @returns {string} Feedback URL with query params where possible.
 */
export function getFeedbackUrl(urlOrDomain, type = 'extraction_failure') {
  let domain = '';
  if (urlOrDomain) {
    try {
      domain = new URL(urlOrDomain).hostname;
    } catch {
      // Already a bare domain or invalid — use as-is
      domain = urlOrDomain;
    }
  }

  const params = new URLSearchParams({ type });
  if (domain) params.set('domain', domain);
  return `${FEEDBACK_BASE_URL}?${params.toString()}`;
}
